import { render, staticRenderFns } from "./OzIconButton.vue?vue&type=template&id=63a5335c&"
import script from "./OzIconButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzIconButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports